import loadable from '@loadable/component'

export const MarketplaceIndexAsync = loadable(() => {
  return import('./index')
})

export default MarketplaceIndexAsync
